<template>
    
    <ul style=" list-style-type: none;padding: 0;">
        <router-link to="/"> <li class="m-3 text-primary">Accueil</li></router-link>
        <router-link to="/concept-sacs-personnalisés"><li class="m-3 text-primary">Concept</li></router-link>
        <router-link to="/se-connecter"><li class="m-3 text-primary">Espace Client</li></router-link>

        <!-- <router-link to="/atouts-sacs-publicitaires"> <li class="m-3 text-primary">Atouts</li></router-link> -->

    </ul>

</template>

<script>
export default ({
    name: "footer-Shop"
})
</script>


